<template>
  <div class="size-variant-picker" role="radiogroup" :class="[{ '-touch-buttons': touchButtons }, theme]">
    <button
      role="radio"
      :aria-checked="modelValue === index ? 'true' : 'false'"
      :aria-label="'Size ' + item.Size"
      class="size-variant-picker-item -stripped"
      v-for="(item, index) in variants"
      :key="index"
      :class="{
        '-small': small,
        '-selected': modelValue === index,
        '-disabled -thin':
          grayOut ||
          (!(item.Inventory >= minimumInventory || disabled) && !forceEnable),
        '-dead -thin': disabled,
        '-longtext': item.Size.length > 3,
      }"
      tabindex="0"
      @click.stop="changeSize(item, index)"
      @keypress.enter="changeSize(item, index)"
    >
      <span :ref="'size' + index" class="no-font-spacing">{{ item.Size }}</span>
    </button>
    <div id="selected-size-announcement" class="sr-only" aria-live="polite">Selected size {{ selectedSize }}</div>
  </div>
</template>
<script>

export default {
  name: 'SizeVariantPicker',
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    modelValue: Number,
    variants: Array,
    small: Boolean,
    label: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    grayOut: Boolean,
    touchButtons: {
      type: Boolean,
      default: false
    },
    forceEnable: Boolean,
    editMode: Boolean,
    outlet: Boolean,
    theme: String
  },
  data () {
    return {
      defaultMinimumInventory: 1,
      outletMinimumInventory: 1,
      selectedSize: String
    };
  },
  computed: {
    minimumInventory () {
      if (this.outlet) {
        return this.outletMinimumInventory;
      }
      return this.defaultMinimumInventory;
    }
  },
  methods: {
    changeSize (item, index) {
      this.$emit('change', index);
      this.selectedSize = item.Size;
      this.$nextTick(() => {
        // set the aria checked attribute to true for the selected size
        this.$refs['size' + index][0].setAttribute('aria-checked', 'true');
      });
    }
  }
};
</script>

<style lang="scss">
@import "@/scss/defaults.scss";

$circel-diameter-xs: 30px;
$circel-diameter-md: 30px;

@function circle-spacing($diameter) {
  @return $diameter * 1;
}

.size-variant-picker {
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  overflow: hidden;

  .size-variant-picker-item {
    cursor: pointer;
    display: inline-block;
    padding: 1px 15px 0;
    color: $black;
    @include font-responsive(small, bold);

    &:last-of-type {
      padding-right: 0;
    }

    &:first-of-type {
      padding-left: 0;
    }

    > span {
      display: inline-block;
      border-bottom: 1px solid transparent;
      padding: 2px 1px 1px 1px;
    }

    &:hover span {
      border-color: currentColor;
    }
    &.-small {
      padding: 1px 6px 0;
    }

    &.-selected {
      pointer-events: none;
      cursor: default;

      > span {
        border-color: currentColor;
      }
    }

    &.-disabled {
      opacity: 0.61;
      // pointer-events: none;
      // cursor: default;
    }
    &.-dead {
      opacity: 0.61;
      pointer-events: none;
      cursor: default;
    }
  }

  &.-touch-buttons {
    .size-variant-picker-item {
      background-color: $gray-lighter;
      border-radius: 18px;
      width: 36px;
      height: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: unset;
      margin-right: 12px;
      &.-longtext {
        span {
          text-align: center;
          font-size: 11px;
          line-height: 1;
        }
      }

      &.-selected {
        background-color: $green-light;

        > span {
          border: none;
        }
      }

      &.-disabled {
        background-color: transparent;
      }
    }
  }

  &.-white-buttons {
     .size-variant-picker-item {
        background-color: $white;
     }
  }
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(1px, 1px, 1px, 1px);
    clip-path: inset(50%);
    border: 0;
  }
}
</style>
